import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { CustomerResponseDto } from "src/dtos/customer/customerResponseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/customer`;

export const createCustomer = async (data: CustomerResponseDto) => {

  return await postData<CustomerResponseDto, ResponseDto<any>>(baseUrl, data);
}

export const getCustomerList = async (areaCd: string, searchText?: string) => {
  // areaCd가 'all'이면 빈 문자열로 처리
  const url = `${baseUrl}/area/${areaCd}`;

  // searchText가 'all'이거나 빈 값이면 파라미터를 전송하지 않음
  const params = searchText && searchText !== 'all' && searchText.trim() !== '' ? {
    searchText
  } : undefined;

  return await getData<ResponseDto<CustomerResponseDto[]>>(url, params ? { params } : undefined);
}

// searchText로 거래처 검색하는 함수 (다른 컬럼도 검색 가능)
export const searchCustomer = async (searchText: string) => {
  const url = `${baseUrl}/${searchText.trim()}`;
  return await getData<ResponseDto<CustomerResponseDto[]>>(url);
}


export const deleteCustomer = async (custCd: string) => {
  const url = `${baseUrl}/${custCd}`;

  return await deleteData<ResponseDto<any>>(url);
}

export const patchCustomer = async (data: CustomerResponseDto) => {

  return await patchData<CustomerResponseDto, ResponseDto<any>>(baseUrl, data);
}

export const downloadCustomerExcel = async (areaCd: string, searchText?: string) => {
  const url = `${baseUrl}/excel`;

  const params: {
    areaCd: string;
    searchText?: string;
  } = {
    areaCd
  }
  if (searchText) params.searchText = searchText;

  return await getData<ResponseDto<string>>(url, {
    params
  });
}